export * from './lib/FeatureProductTileMedium';
